<div class="container">
    <app-solicitud-servicio 
        [title]="'Ajuste solicitud de servicio'"
        [$views]="6"
        [solicitudId]="codeSolicitud"
        (solicitudUpdate)="updateSolicitud($event)">
    </app-solicitud-servicio>
</div>
